export default {
    ar : {
        message : {
            Accept : "حسنا",
            Cancel : "الغاء",
            Close : "اغلاق"
        }
    },
    az : {
        message : {
            "Accept" : "Ok",
            "Cancel" : "Ləğv et",
            "Close" : "Bağla"
        }
    },
    bg : {
        message : {
            Accept : "ОК",
            Cancel : "Отмени",
            Close : "Затвори"
        }
    },
    bs : {
        message : {
            Accept : "OK",
            Cancel : "Odustani",
            Close : "Zatvori"
        }
    },
    ca : {
        message : {
            Accept : "D'acord",
            Cancel : "Cancel·la",
            Close : "Tanca"
        }
    },
    cs : {
        message : {
            Accept : "OK",
            Cancel : "Storno",
            Close : "Zavřít"
        }
    },
    da : {
        message : {
            Accept : "OK",
            Cancel : "Annullér",
            Close : "Luk"
        }
    },
    de : {
        message : {
            Accept : "OK",
            Cancel : "Abbrechen",
            Close : "Schließen"
        }
    },
    el : {
        message : {
            Accept : "ΟΚ",
            Cancel : "Ακύρωση",
            Close : "Κλείσιμο"
        }
    },
    en : {
        message : {
            Accept : "Accept",
            Cancel : "Cancel",
            Close : "Close"
        }
    },
    es : {
        message : {
            Accept : "Aceptar",
            Cancel : "Cancelar",
            Close : "Cerrar"
        }
    },
    eu : {
        message : {
            Accept : "Ados",
            Cancel : "Utzi",
            Close : "Itxi"
        }
    },
    fi : {
        message : {
            Accept : "OK",
            Cancel : "Peruuta",
            Close : "Sulje"
        }
    },
    fr : {
        message : {
            Accept : "OK",
            Cancel : "Annuler",
            Close : "Fermer"
        }
    },
    he : {
        message : {
            Accept : "אישור",
            Cancel : "ביטול",
            Close : "סגירה"
        }
    },
    hr : {
        message : {
            Accept : "OK",
            Cancel : "Opoziv",
            Close : "Zatvori"
        }
    },
    hu : {
        message : {
            Accept : "OK",
            Cancel : "Mégse",
            Close : "Bezárás"
        }
    },
    id : {
        message : {
            Accept : "OK",
            Cancel : "Batal",
            Close : "Tutup"
        }
    },
    it : {
        message : {
            Accept : "Ok",
            Cancel : "Annulla",
            Close : "Chiudi"
        }
    },
    ja : {
        message : {
            Accept : "OK",
            Cancel : "キャンセル",
            Close : "閉じる"
        }
    },
    kk : {
        message : {
            Accept : "OK",
            Cancel : "Болдырмау",
            Close : "Жабу"
        }
    },
    ko : {
        message : {
            Accept : "확인",
            Cancel : "취소",
            Close : "닫기"
        }
    },
    mk : {
        message : {
            Accept : "OK",
            Cancel : "Откажи",
            Close : "Затвори"
        }
    },
    nb : {
        message : {
            Accept : "OK",
            Cancel : "Avbryt",
            Close : "Lukk"
        }
    },
    nl : {
        message : {
            Accept : "OK",
            Cancel : "Annuleren",
            Close : "Sluiten"
        }
    },
    pl : {
        message : {
            Accept : "OK",
            Cancel : "Anuluj",
            Close : "Zamknij"
        }
    },
    pt : {
        message : {
            Accept : "OK",
            Cancel : "Cancelar",
            Close : "Fechar"
        }
    },
    "pt-pt" : {
        message : {
            Accept : "OK",
            Cancel : "Cancelar",
            Close : "Fechar"
        }
    },
    ro : {
        message : {
            Accept : "OK",
            Cancel : "Anulare",
            Close : "Închidere"
        }
    },
    ru : {
        message : {
            Accept : "OK",
            Cancel : "Отмена",
            Close : "Закрыть"
        }
    },
    sk : {
        message : {
            Accept : "OK",
            Cancel : "Zrušiť",
            Close : "Zatvoriť"
        }
    },
    sl : {
        message : {
            Accept : "V redu",
            Cancel : "Prekliči",
            Close : "Zapri"
        }
    },
    sr : {
        message : {
            Accept : "U redu",
            Cancel : "Otkaži",
            Close : "Zatvori"
        }
    },
    sv : {
        message : {
            Accept : "OK",
            Cancel : "Avbryt",
            Close : "Stäng"
        }
    },
    th : {
        message : {
            Accept : "ตกลง",
            Cancel : "ยกเลิก",
            Close : "ปิด"
        }
    },
    tr : {
        message : {
            Accept : "Tamam",
            Cancel : "İptal",
            Close : "Kapat"
        }
    },
    uk : {
        message : {
            Accept : "OK",
            Cancel : "Скасувати",
            Close : "Закрити"
        }
    },
    zh : {
        message : {
            Accept : "确定",
            Cancel : "取消",
            Close : "关闭"
        }
    },
    "zh-tw" : {
        message : {
            Accept : "確定",
            Cancel : "取消",
            Close : "關閉"
        }
    }
}